import React, { createRef } from 'react';
import { Renderer } from 'core/renderers';
import styles from './MyValueInputRenderer.module.scss';
import { getCurrentPlayer } from 'components/Player';
import { MyCurrentJsData } from 'apis';
import { MyNumberInput } from './inputs/numberInput';
import { MyMatrixInput } from './inputs/matrixInput';
import * as _ from 'lodash';
import { MyDropdownInput } from './inputs/dropdownInput';

class MyValueInputRenderer extends Renderer {
  constructor(props) {
    super(props);
    this.togglePan(true);
    this.toggleZoom(true);
    this.containerRef = createRef();
    this.state = {
      variables: this.props.data.data.variables,
      options: this.props.data.data.options,
      isValid: true,
      isUnfolded: true,
      marginLeft: ''
    };
    const variables = this.state.variables || {};
    this.inputRendererRefs = Object.keys(variables).reduce((acc, key) => {
      acc[key] = createRef();
      return acc;
    }, {});
  }

  componentDidMount() {
    if (this.containerRef.current) {
      const width = this.containerRef.current.offsetWidth;
      const marginLeft = `calc(100% - ${width / 2}px)`;
      this.setState({ marginLeft });
    }
  }

  reBuild() {
    const player = getCurrentPlayer();
    const file = player.getJSFile();
    for (const varName in this.state.variables) {
      const obj = this.state.variables[varName];
      MyCurrentJsData[varName] = obj.value;
    }
    player.build(file);
  }

  onOk(ev) {
    ev.preventDefault();
    this.setDefaultValuesForAll();
    if (!this.validate()) {
      alert("Die Eingabe ist ungültig.")
      return;
    }
    setTimeout(this.reBuild.bind(this), 100);
  }

  setDefaultValuesForAll() {
    for (const varIdentifier in this.inputRendererRefs) {
      const ref = this.inputRendererRefs[varIdentifier];
      if (ref.current.setDefaultValuesForAll)  {
        ref.current.setDefaultValuesForAll();
      }
    }
  }

  onRandom(ev) {
    ev.preventDefault();
    for (const varIdentifier in this.inputRendererRefs) {
      const ref = this.inputRendererRefs[varIdentifier];
        ref?.current?.randomize();
  }
    setTimeout(() => this.validate(), 1);
    setTimeout(this.reBuild.bind(this), 100);
  }

  validate() {
    let result = true;
    for (const varIdentifier in this.inputRendererRefs) {
      const ref = this.inputRendererRefs[varIdentifier];
       if (!ref || !ref.current || !ref.current.validate) {
      continue;
    }
    result = result && ref.current.validate();
    }
    this.setState({ isValid: result });
    return result;
  }

  onUpdate() {
    this.validate();
    this.forceUpdate();
  }
  isInputHidden(data) {
  if (!data.hidden) {
    return false;
  }

  try {
    const rawVariables = this.state.variables || {};
    const variables = {};

    Object.keys(rawVariables).forEach(key => {
      variables[key] = rawVariables[key]?.value;
    });

    return !!Function('variables', `with (variables) { return (${data.hidden}); }`)(variables);
  } catch (e) {
    return false;
  }
}

  showGenerateButtons() {
    let displayRandomizeButton = false;
    for (var prop in this.state.variables) {
      if (this.state.variables[prop]["randomizeValues"] || this.state.variables[prop]["randomize"]) {
        displayRandomizeButton = true;
      }
    }

    return (
      <>
        {displayRandomizeButton && (
          <button onClick={this.onRandom.bind(this)}>
            Zufällige Generierung
          </button>
        )}
        <button onClick={this.onOk.bind(this)}>OK</button>
      </>
    )
  }

  renderData() {
    const variables = [];
    for (const varIdentifier in this.state.variables) {
      const data = this.state.variables[varIdentifier];
      const name = data.name;
      const hidden = this.isInputHidden(data);
      if (data.type === 'numberInput') {
        variables.push(
          <div className={styles.inputEntry} key={varIdentifier} style={hidden ? {display: 'none'} : {}}>
            <span>{name}</span>
            <MyNumberInput ref={this.inputRendererRefs[varIdentifier]} onUpdate={this.onUpdate.bind(this)} data={data} variables={this.state.variables}></MyNumberInput>
          </div>
        )
      }
      if (data.type === 'dropdownInput') {
        variables.push(
          <div className={styles.inputEntry} key={varIdentifier} style={hidden ? {display: 'none'} : {}}>
            <span>{name}</span>
            <MyDropdownInput ref={this.inputRendererRefs[varIdentifier]} onUpdate={this.onUpdate.bind(this)} data={data} onValueChange={this.validate.bind(this)} variables={this.state.variables}></MyDropdownInput>
          </div>
        )
      }
      if (data.type === 'matrixInput') {
        variables.push(
          <div className={styles.inputEntry} key={varIdentifier} style={hidden ? {display: 'none'} : {}}>
            <span>{name}</span>
            <MyMatrixInput ref={this.inputRendererRefs[varIdentifier]} onUpdate={this.onUpdate.bind(this)} data={data} onValueChange={this.validate.bind(this)} variables={this.state.variables}></MyMatrixInput>
          </div>
        )
      }
    }

    this.moveX = -this.centerX;
    this.moveY = -this.centerY;
    return (
      <div
        ref={this.containerRef}
        style={{
          transform: `translate(${this.moveX}px, ${this.moveY}px) scale(${this.zoom})`,
          width: '100%',
          transformOrigin: 'left center',
          marginLeft: this.state.marginLeft,
          marginTop: '10%'
        }}
      >
        <div className={styles.myInputRenderer}>
          <form>
            {variables}
            <p className={this.state.isValid ? styles.invisible : styles.errorText}>
              Die Eingabe ist ungültig!
            </p>
          </form>
          <br />
        </div>
      </div>
    );
  }
}

export default MyValueInputRenderer;

